import { PatientSource } from '@heidi/schema/ml-scribe';

import type { PatientProfile, PatientProfileSearchResult } from '../../../contracts';

/**
 * Adapts real all-patient profile data into the search-result row shape.
 * Suggested matches use their own stub/API model and do not go through this mapper.
 */
export function toPatientProfileSearchResult(
  profile: PatientProfile
): PatientProfileSearchResult | null {
  if (!profile.id) return null;

  return {
    id: profile.id,
    source: profile.source === PatientSource.EHR ? 'EHR' : 'HEIDI',
    first_name: profile.first_name ?? null,
    last_name: profile.last_name ?? null,
    birth_date: profile.birth_date ?? null,
    gender: profile.gender ?? null,
    demographic_string: profile.demographic_string ?? '',
    last_seen_at: null,
    last_session_gist: null,
    session_count: 0,
  };
}

export function toPatientProfileSearchResults(
  profiles: readonly PatientProfile[] | null | undefined
): PatientProfileSearchResult[] {
  return (
    profiles?.flatMap((profile) => toPatientProfileSearchResult(profile) ?? []) ?? []
  );
}
